/* audemu-cart-summary: ausgelagert aus snippets/audemu-cart-summary-assets.liquid (Speed 24.09.26) */
  (function () {
    if (window.__audmCartSummary) return;
    window.__audmCartSummary = true;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var busy = false;
    var lastKey = null;

    /* Land -> Name und ein Beispiel-PLZ. Die Raten-Schnittstelle verlangt
       beides, der Landescode allein wird mit 422 abgewiesen. */
    var PLACES = {
      DE: ['Germany', '10115', 'Deutschland'],   AT: ['Austria', '1010', 'Österreich'],
      CH: ['Switzerland', '8001', 'die Schweiz'], NL: ['Netherlands', '1011AA', 'die Niederlande'],
      BE: ['Belgium', '1000', 'Belgien'],        FR: ['France', '75001', 'Frankreich'],
      IT: ['Italy', '00118', 'Italien'],         ES: ['Spain', '28001', 'Spanien'],
      PL: ['Poland', '00-001', 'Polen'],         DK: ['Denmark', '1050', 'Dänemark'],
      SE: ['Sweden', '11120', 'Schweden'],       FI: ['Finland', '00100', 'Finnland'],
      CZ: ['Czechia', '11000', 'Tschechien'],    LU: ['Luxembourg', '1111', 'Luxemburg'],
      IE: ['Ireland', 'D01', 'Irland'],          PT: ['Portugal', '1000-001', 'Portugal']
    };

    /* Der Block kann zweimal im Dokument stehen: in der Warenkorb-Schublade
       und auf der Warenkorb-Seite. Deshalb nie global suchen, sondern immer
       innerhalb der jeweiligen Instanz. */
    function boxes() { return Array.prototype.slice.call(document.querySelectorAll('[data-audm-sum]')); }
    function inBox(b, sel) { return b ? b.querySelector(sel) : null; }

    /* Formatiert mit dem Format des Shops, damit die Zahlen exakt so
       aussehen wie die von Liquid gerenderten. */
    function money(cents, format) {
      var value = (cents || 0) / 100;
      function withSep(dec, thousands, decimal) {
        var parts = value.toFixed(dec).split('.');
        var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return dec > 0 ? int + decimal + parts[1] : int;
      }
      return String(format || '{{amount}} EUR').replace(
        /\{\{\s*(\w+)\s*\}\}/,
        function (_, name) {
          switch (name) {
            case 'amount_no_decimals': return withSep(0, ',', '');
            case 'amount_with_comma_separator': return withSep(2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': return withSep(0, '.', '');
            case 'amount_with_apostrophe_separator': return withSep(2, "'", '.');
            default: return withSep(2, ',', '.');
          }
        }
      );
    }

    function getCart() {
      return fetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
    }

    function cheapestRate(country) {
      var place = PLACES[country] || PLACES.DE;
      var url = root + 'cart/shipping_rates.json'
        + '?shipping_address%5Bcountry%5D=' + encodeURIComponent(place[0])
        + '&shipping_address%5Bzip%5D=' + encodeURIComponent(place[1]);

      return fetch(url, { cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var list = (j && j.shipping_rates) || [];
          if (!list.length) return null;
          return list.reduce(function (min, r) {
            var p = Math.round(parseFloat(r.price) * 100);
            return min === null || p < min ? p : min;
          }, null);
        })
        .catch(function () { return null; });
    }

    function renderOne(wrap, cart, shipCents) {
      if (!wrap) return;

      var format = wrap.getAttribute('data-money-format') || '';
      var country = wrap.getAttribute('data-country') || 'DE';
      var place = PLACES[country] || PLACES.DE;

      var shipLabel = inBox(wrap, '[data-audm-ship-label]');
      var shipValue = inBox(wrap, '[data-audm-ship]');
      var grand = inBox(wrap, '[data-audm-grand]');
      var free = inBox(wrap, '[data-audm-free]');

      if (shipLabel) {
        // Deutschland: "in", Laender mit Artikel: "in die", sonst "nach".
        var name = place[2] || place[0];
        var prep = country === 'DE' ? 'in' : (/^die /.test(name) ? 'in' : 'nach');
        shipLabel.textContent = 'Versand ' + prep + ' ' + name;
      }

      if (shipCents === null) {
        if (shipValue) shipValue.textContent = 'wird im Checkout berechnet';
        if (grand) grand.textContent = money(cart.total_price, format);
      } else {
        if (shipValue) shipValue.textContent = shipCents === 0 ? 'kostenlos' : money(shipCents, format);
        if (grand) grand.textContent = money(cart.total_price + shipCents, format);
      }

      if (!free) return;
      var threshold = parseInt(
        country === 'DE' ? wrap.getAttribute('data-free-de') : wrap.getAttribute('data-free-eu'),
        10
      );
      var missing = threshold - cart.total_price;
      if (shipCents !== null && shipCents > 0 && missing > 0 && cart.item_count > 0) {
        free.innerHTML = 'Noch <b>' + money(missing, format) + '</b> bis zum kostenlosen Versand.';
        free.hidden = false;
      } else if (shipCents === 0 && cart.item_count > 0) {
        free.textContent = 'Versandkostenfrei erreicht.';
        free.hidden = false;
      } else {
        free.hidden = true;
      }
    }

    /* Produktbezogene Codes stehen nicht in cart_level_discount_applications,
       Liquid rendert dann das Eingabefeld. Hier aus /cart.js nachziehen. */
    function renderCodesFromCart(wrap, cart) {
      var codes = codesOf(cart);
      var row = inBox(wrap, '[data-audm-discount-row]');
      if (!codes.length || !row || inBox(wrap, '.audm-sum__codes')) return;
      var format = wrap.getAttribute('data-money-format') || '';
      var box = document.createElement('div');
      box.className = 'audm-sum__codes';
      box.innerHTML = '<div class="audm-sum__code"><span class="audm-chip">'
        + '<svg class="audm-chip__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7" cy="7" r="1.2" fill="currentColor" stroke="none"/></svg>'
        + '<span class="audm-chip__code audm-sum__codeName"></span>'
        + '<button type="button" class="audm-chip__x" data-audm-discount-remove aria-label="Rabattcode entfernen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
        + '</span>'
        + (cart.total_discount > 0 ? '<span class="audm-sum__codeVal">\u2212' + money(cart.total_discount, format) + '</span>' : '')
        + '</div>';
      box.querySelector('.audm-sum__codeName').textContent = codes.join(', ');
      row.parentNode.insertBefore(box, row);
      row.hidden = true;
      var msg = inBox(wrap, '[data-audm-discount-msg]');
      if (msg) msg.hidden = true;
    }

    /* Jeder Kasten merkt sich den gezeichneten Stand (data-audm-key). So wird
       ein neu eingesetzter Kasten (Slider neu aufgebaut) immer gezeichnet, ein
       bereits aktueller nie ein zweites Mal. Das Attribut loest den
       Beobachter nicht aus (er beobachtet nur Kindknoten), deshalb keine Schleife. */
    function render(cart, shipCents, key) {
      boxes().forEach(function (b) {
        if (key && b.getAttribute('data-audm-key') === key) return;
        renderOne(b, cart, shipCents);
        renderCodesFromCart(b, cart);
        if (key) b.setAttribute('data-audm-key', key);
      });
    }

    /* Shopify haengt beim Sprung zur Kasse ein leeres discount= an die URL
       (Storefront-Cookie) und loescht damit den im Warenkorb gesetzten Code.
       Reproduziert am 22.9. Deshalb bekommt jedes Kasse-Formular den Code
       als verstecktes Feld mit; ohne Code wird das Feld entfernt, damit nie
       ein leerer Wert mitgeht. */
    function syncDiscountField(cart) {
      var codes = (cart.discount_codes || [])
        .filter(function (c) { return c && c.applicable !== false && c.code; })
        .map(function (c) { return c.code; });
      var forms = document.querySelectorAll('form[action*="/cart"]');
      for (var i = 0; i < forms.length; i++) {
        var f = forms[i];
        /* Der Kasse-Knopf haengt per form="..."-Attribut am Formular, nicht
           darin. Deshalb ueber f.elements pruefen, nicht per querySelector. */
        var hasCheckout = false;
        for (var k = 0; k < f.elements.length; k++) { if (f.elements[k].name === 'checkout') { hasCheckout = true; break; } }
        if (!hasCheckout) continue;
        var field = f.querySelector('input[name="discount"][data-audm-discount-field]');
        if (codes.length) {
          if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = 'discount';
            field.setAttribute('data-audm-discount-field', '1');
            f.appendChild(field);
          }
          field.value = codes.join(',');
        } else if (field) {
          field.parentNode.removeChild(field);
        }
      }
    }

    function update() {
      var all = boxes();
      if (!all.length) return;
      var country = all[0].getAttribute('data-country') || 'DE';

      getCart().then(function (cart) {
        syncDiscountField(cart);
        /* Nur zeichnen, wo sich etwas geaendert hat (Schluessel pro Kasten).
           Frueher zeichnete der leere Warenkorb bei jedem Durchlauf neu, das
           loeste den Beobachter aus, der wieder /cart.js holte: Endlosschleife
           (gemessen 24.09.26, ca. 1 Abruf pro Sekunde im Hintergrund-Tab). */
        if (!cart.item_count) return render(cart, 0, 'empty');
        return cheapestRate(country).then(function (ship) {
          var key = cart.total_price + '|' + ship + '|' + cart.item_count + '|' + codesOf(cart).join(',');
          render(cart, ship, key);
        });
      }).catch(function () {});
    }

    /* ---------- Rabattcode ---------- */

    function codesOf(cart) {
      return (cart.discount_codes || [])
        .filter(function (c) { return c && c.applicable !== false; })
        .map(function (c) { return String(c.code || '').toUpperCase(); });
    }

    function setDiscount(code) {
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      });
    }

    function redraw(fromBox) {
      // Auf der Warenkorb-Seite muessen auch Positionen und Summen der Seite
      // neu kommen. Das leistet der Abschnitts-Abruf der Schublade nicht.
      if (fromBox && !fromBox.closest('cart-drawer')) {
        window.location.reload();
        return Promise.resolve();
      }
      return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents({ sections: sections });
            lastKey = null;
            update();
            setTimeout(function () { getCart().then(syncDiscountField).catch(function () {}); }, 400);
          } else {
            window.location.reload();
          }
        });
    }

    function message(wrap, text, isError) {
      var m = inBox(wrap, '[data-audm-discount-msg]');
      if (!m) return;
      m.textContent = text || '';
      m.classList.toggle('audm-sum__msg--err', !!isError);
      m.hidden = !text;
    }

    function setBusy(wrap, state) {
      busy = state;
      var go = inBox(wrap, '[data-audm-discount-submit]');
      if (go) go.disabled = state;
      var x = inBox(wrap, '[data-audm-discount-remove]');
      if (x) x.disabled = state;
    }

    function apply(wrap, code) {
      if (busy || !code) return;
      setBusy(wrap, true);
      message(wrap, 'Wird geprüft …', false);

      var previous = null;
      getCart()
        .then(function (before) {
          previous = codesOf(before)[0] || null;
          return setDiscount(code);
        })
        .then(getCart)
        .then(function (after) {
          if (codesOf(after).indexOf(code.toUpperCase()) !== -1) return redraw(wrap);
          /* Shopify meldet einen ungueltigen Code nicht, loescht dabei aber
             einen bereits gesetzten. Deshalb den alten wiederherstellen. */
          return (previous ? setDiscount(previous) : Promise.resolve()).then(function () {
            message(wrap, 'Dieser Code gilt für deinen Warenkorb nicht.', true);
          });
        })
        .catch(function () { message(wrap, 'Das hat gerade nicht geklappt.', true); })
        .then(function () { setBusy(wrap, false); });
    }

    function remove(wrap) {
      if (busy) return;
      setBusy(wrap, true);
      setDiscount('')
        .then(function () { return redraw(wrap); })
        .catch(function () { window.location.reload(); })
        .then(function () { setBusy(wrap, false); });
    }

    function typed(wrap) {
      var i = inBox(wrap, '[data-audm-discount-input]');
      return i ? i.value.trim() : '';
    }

    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;
      var wrap = e.target.closest('[data-audm-sum]');
      if (!wrap) return;

      if (e.target.closest('[data-audm-discount-submit]')) { e.preventDefault(); apply(wrap, typed(wrap)); return; }
      if (e.target.closest('[data-audm-discount-remove]')) { e.preventDefault(); remove(wrap); }
    });

    document.addEventListener('input', function (e) {
      if (!(e.target instanceof Element)) return;
      if (!e.target.matches('[data-audm-discount-input]')) return;
      var row = e.target.closest('[data-audm-discount-row]');
      if (row) row.classList.toggle('is-filled', e.target.value.trim().length > 0);
    });

    /* Das Feld liegt im Warenkorb-Formular. Ohne preventDefault wuerde Enter
       das Formular abschicken und direkt zur Kasse springen. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      if (!(e.target instanceof Element) || !e.target.matches('[data-audm-discount-input]')) return;
      e.preventDefault();
      e.stopPropagation();
      var wrap = e.target.closest('[data-audm-sum]');
      if (wrap) apply(wrap, typed(wrap));
    });

    /* ---------- Ausloeser ---------- */

    /* /cart schickt den Besucher zurueck und setzt dabei ein Flag
       (sections/audemu-cart-redirect.liquid). Hier wird es genau einmal
       eingeloest: Schublade auf, Flag weg. */
    function openDrawerIfFlagged() {
      var flag = null;
      try {
        flag = sessionStorage.getItem('audm_open_cart');
        if (flag) sessionStorage.removeItem('audm_open_cart');
      } catch (e) {}
      if (flag !== '1') return;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      setTimeout(function () { drawer.open(); }, 150);
    }

    function boot() {
      update();
      openDrawerIfFlagged();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { lastKey = null; update(); });
      }

      var drawer = document.querySelector('cart-drawer') || document.querySelector('main');
      if (drawer && 'MutationObserver' in window) {
        var pending = false;
        new MutationObserver(function () {
          if (pending) return;
          pending = true;
          setTimeout(function () { pending = false; update(); }, 120);
        }).observe(drawer, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
